/* eslint-disable */
import { SiteHeader } from './modules/_siteHeader.es6';

const callback = function () {
    'use strict';
    const header = document.querySelector('.site-header__mega-menu');
    if(header) {
      const siteHeader = new SiteHeader(header);
      siteHeader.init();
    }
};

if (
  document.readyState === 'complete' ||
  (document.readyState !== 'loading' && !document.documentElement.doScroll)
) {
  callback();
} else {
  document.addEventListener('DOMContentLoaded', callback);
}
